import Calculator from './components/Calculator';

import './css/CalcPage.css';

const CalcPage = () => (
  <div className="content calc-page">
    <h2>Let&apos;s do some math!</h2>
    <Calculator />
  </div>
);

export default CalcPage;
